export const operatorsWork = [
  { name: "Олена R.", start: "11:00", end: "20:00" },
  { name: "Ігор M.", start: "11:00", end: "20:00" },
  { name: "Максим Ж.", start: "11:00", end: "20:00" },
  { name: "Світлана K.", start: "11:00", end: "20:00" },
  { name: "Андрій C.", start: "11:00", end: "20:00" },
];
